import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { map, catchError } from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { GenericVm } from 'src/app/shared/models/system/generic-vm';
import { Message } from 'src/app/shared/models/system/message';
import { MessageEnum } from 'src/app/shared/models/system/message.enum';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  reqData;
  msgs;
   httpOptions ;
  globals: any;
  translate: any;

  constructor(private configService: ConfigService, private httRequest: HttpRequestService) {

    this.httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
  }

  sendEmail(data) {
    console.log(data);
    return this.httRequest.postRequest('Patients/ForgetPasswordMail',data);
  }

  ChangePassword(data) {
    console.log(data);
    return this.httRequest.postRequest('Accounts/ChangePassword/',JSON.stringify(data)).pipe(map((res: any)=>res),catchError(err=>{console.error(err);return throwError(err)}));
  }


  ForgetPassword(data) {
    return this.httRequest.postRequest('Patients/ForgetPassword',data);
  }
}
